import {useEffect, useState} from 'react';
import useChatMessagesStore from '../store/useChatMessagesStore';

const BASE = process.env.REACT_APP_AWP_API_URL || 'https://awp.minsky.ai';
function _authH() { const t = localStorage.getItem('access_token'); return t ? {'Authorization': `Bearer ${t}`} : {}; }

export const useFetchMessages = (chatId) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const replaceMessages = useChatMessagesStore(state => state.replaceMessages);

    useEffect(() => {
        if (!chatId) { setLoading(false); return; }

        setLoading(true); setError(null);
        fetch(`${BASE}/api/chats/${encodeURIComponent(chatId)}/messages`, {headers: _authH()})
            .then(r => r.ok ? r.json() : [])
            .then(msgs => {
                const messages = (Array.isArray(msgs) ? msgs : []).map(m => ({chatId, ...m}));
                replaceMessages(chatId, messages);
                setLoading(false);
            })
            .catch(err => { setError(err); setLoading(false); });
    }, [chatId, replaceMessages]);

    return {loading, error};
};
